export class OpeningHours {
    constructor(locationDetails) {
        this.locationDetails = locationDetails;

        this.initStatus()
            .then(() => this.initializeTodayMarker());
    }

    initializeTodayMarker() {
        const days = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];
        const today = this.getFormattedTime(new Date());

        document
            .querySelectorAll('.location-detail__day--current, .location-detail__day--' + days[(new Date).getDay()] + ', .location-detail__day--' + today )
            .forEach(element => {
                this.isCurrentlyOpen().then(status => {
                    const elemSpecialToday = document.getElementsByClassName('location-detail__day--' + today)[0];
                    const elemRegularSelectedDay = document.getElementsByClassName('location-detail__day--' + days[(new Date).getDay()])[0];
                    const elemRegularSelectedTime = document.getElementsByClassName('location-detail__day--' + days[(new Date).getDay()])[1];

                    if(status) {
                        element.classList.add(this.locationDetails.getClassName('day', 'open'))
                        if(elemSpecialToday && elemSpecialToday.classList.contains("location-detail__day--open")) {
                            elemRegularSelectedDay.classList.remove("location-detail__day--open");
                            elemRegularSelectedTime.classList.remove("location-detail__day--open");
                        }
                    } else {
                        element.classList.add(this.locationDetails.getClassName('day', 'closed'))
                        if(elemSpecialToday && elemSpecialToday.classList.contains("location-detail__day--closed")) {
                            elemRegularSelectedDay.classList.remove("location-detail__day--closed");
                            elemRegularSelectedTime.classList.remove("location-detail__day--closed");
                        }
                    }
                });
            });
    }

    parseTimeData(time) {
        if (!time) return 0;
        const timeRegex = /^([0-9]{2}):([0-9]{2})/
        const match = time.match(timeRegex);
        if (match) {

            const hours = parseInt(match[1]);
            const minutes = parseInt(match[2]);

            return hours * 60 + minutes;
        }
        return -1;
    }

    getCurrentTime() {
        const date = new Date();
        const hour = date.getHours() < 10 ? '0' + date.getHours().toString() : date.getHours().toString();
        const minutes = date.getMinutes() < 10 ? '0' + date.getMinutes().toString() : date.getMinutes().toString();
        return this.parseTimeData(`${hour}:${minutes}`);
    }

    getFormattedTime(time) {
        let yyyy = time.getFullYear();
        let mm = time.getMonth() + 1;
        let dd = time.getDate();

        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;

        return dd + '-' + mm + '-' + yyyy;
    }

    isOpenCalculation(isDayValid, closed, from1, to1, from2, to2) {
        if(!isDayValid) return false;
        const from1Time = this.parseTimeData(from1);
        const to1Time = this.parseTimeData(to1);
        const from2Time = this.parseTimeData(from2);
        const to2Time = this.parseTimeData(to2);
        const currentTime = this.getCurrentTime();

        return !closed && ((from1Time <= currentTime && to1Time >= currentTime) || (from2Time <= currentTime && to2Time >= currentTime))
    }

    isCurrentlyOpen() {

        return this.locationDetails.getData().then(locationData => {
            const days = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
            const todayWeekDay = days[(new Date).getDay()];
            const interval = 1000 * 60 * 60 * 24;
            const timestampToday = Math.floor(Date.now() / interval) * interval; // timestamps: start of today in GMT
            const foundSpecialOpeningHours = locationData.specialOpeningHours?.find(({date, from1, to1, from2, to2}) => date === timestampToday);
            if(foundSpecialOpeningHours) {
                const {closed, from1, to1, from2, to2} = foundSpecialOpeningHours;
                return this.isOpenCalculation(true, closed, from1, to1, from2, to2);
            }
            return  locationData.openingHours ? !!locationData.openingHours.find(({dayOfWeek, from1, to1, from2, to2}) => this.isOpenCalculation(dayOfWeek === todayWeekDay, false, from1, to1, from2, to2)) : true;
        });
    }

    initStatus() {
        return this.isCurrentlyOpen()
            .then(isCurrentlyOpen => {
                this.locationDetails.find('open-status').forEach(status => {
                    if(isCurrentlyOpen) {
                        status.innerHTML = status.dataset.openLabel;
                    } else {
                        status.innerHTML = status.dataset.closedLabel;
                    }
                })
            });
    }


}
